import * as _ from 'lodash';
import React, {
  Fragment,
  memo,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { Col, Row } from 'react-bootstrap';
import { translate } from 'react-i18next';
import PerfectScrollBar from 'react-perfect-scrollbar';
import { PSLIST } from '../../../../utils';
import DatagridPhaisinh from '../../../table/DatagridPhaisinh';
import Tbl10Buy from './tbl10B';
import Tbl10Sell from './tbl10S';
import TblTradeHis from './tblTradeHis';

function TblPhaiSinh({ t, partSnap, typeIndex, psList }) {
  const frameRef = useRef(null);

  const [symbol, setSymbol] = React.useState('');
  const [symbolOrigin, setSymbolOrigin] = useState('');
  const [heightTb, setHeightTb] = useState(470);

  useEffect(() => {
    if (partSnap && !!partSnap.length && !symbol) {
      setSymbol(partSnap[0].sym);
      setSymbolOrigin(PSLIST[0]);
    }
  }, [partSnap]);

  useEffect(() => {
    const heightTb = 470 - (typeIndex === 1 ? 0 : typeIndex === 2 ? 100 : 145);
    setHeightTb(heightTb);
  }, [typeIndex]);

  useEffect(() => {
    const handler = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log('message from frame', data);
      } catch (error) {
        // console.log(error)
      }
    };

    window.addEventListener('message', handler);

    // clean up
    return () => window.removeEventListener('message', handler);
  }, []);

  const memoizedCallback = useCallback((state) => {}, [psList]);

  // const _handleSetSymbolActive = (sym) => {
  //   console.log(sym);
  //   const _sym = PSLIST[_.indexOf(psList, sym)];
  //   setSymbol(sym);
  //   setSymbolOrigin(_sym);
  //   sendMessage(_sym);
  // };

  // const sendMessage = (sym) => {
  //   if (frameRef && frameRef.current && frameRef.current.contentWindow) {
  //     const _data = { symbolChart: sym };
  //     frameRef.current.contentWindow.postMessage(JSON.stringify(_data), '*');
  //   }
  // };

  return (
    <Fragment>
      <div className="tbl-fix-header">
        <DatagridPhaisinh
          resource={[]}
          className="table table-bordered table-fix"
        >
          <tr>
            <th rowSpan="2">{t('txt-symbol')}</th>
            <th rowSpan="2" className="high-light">
              {t('txt-ceil')}
            </th>
            <th rowSpan="2" className="high-light">
              {t('txt-floor')}
            </th>
            <th rowSpan="2" className="high-light">
              {t('txt-ref')}
            </th>
            <th colSpan="6">{t('txt-bid')}</th>
            <th colSpan="4" className="high-light">
              {t('txt-match')}
            </th>
            <th colSpan="6">{t('txt-ask')}</th>
            <th rowSpan="2">{t('txt-total-vol')}</th>
            <th rowSpan="2">{t('txt-oi')}</th>
            <th rowSpan="2" className="high-light">
              {t('txt-high')}
            </th>
            <th rowSpan="2" className="high-light">
              {t('txt-low')}
            </th>
            <th rowSpan="2" className="high-light">
              {t('txt-ave')}
            </th>
            <th rowSpan="2">{'Đáo hạn'}</th>
          </tr>
          <tr>
            <th>{t('txt-price')} 3</th>
            <th>{t('txt-vol')} 3</th>
            <th>{t('txt-price')} 2</th>
            <th>{t('txt-vol')} 2</th>
            <th>{t('txt-price')} 1</th>
            <th>{t('txt-vol')} 1</th>
            <th className="high-light">{t('txt-price')}</th>
            <th className="high-light">{t('txt-vol')}</th>
            <th className="high-light position-relative">{'+/-'}</th>
            <th className="high-light position-relative">#VN30</th>
            <th>{t('txt-price')} 1</th>
            <th>{t('txt-vol')} 1</th>
            <th>{t('txt-price')} 2</th>
            <th>{t('txt-vol')} 2</th>
            <th>{t('txt-price')} 3</th>
            <th>{t('txt-vol')} 3</th>
          </tr>
        </DatagridPhaisinh>
      </div>
      <DatagridPhaisinh
        resource={partSnap}
        className="table table-bordered table-fix"
        clickSymbol={memoizedCallback}
      />
      {/* <div
        className="d-flex flex-row mt-1"
        style={{ height: `calc(100vh - ${heightTb}px)` }}
      >
        <Col className="p-0 pl-1">
          {symbol && (
            <iframe
              ref={frameRef}
              title="chart"
              src={
                'https://banggia.tvs.vn/chartTVS/?resolution=1&symbol=' + symbol
              }
              scrolling="no"
              style={{ height: '100%' }}
            ></iframe>
          )}
        </Col>
        <Col>
          <Row>
            <Col className="p-0 pl-1">
              <PerfectScrollBar
                className="w-100 d-flex flex-column"
                style={{ height: `calc(100vh - ${heightTb}px)` }}
              >
                <h5 className="text-center font-weight-bold txt-content">
                  {symbol}
                </h5>
                <div className="d-flex w-100">
                  <Col className="p-0">
                    <Tbl10Buy sym={symbol} />
                  </Col>
                  <Col className="p-0">
                    <Tbl10Sell sym={symbol} />
                  </Col>
                </div>
              </PerfectScrollBar>
            </Col>
            <Col className="p-0 pl-1">
              <PerfectScrollBar
                className="w-100 d-flex flex-column"
                style={{ height: `calc(100vh - ${heightTb}px)` }}
              >
                <h5 className="text-center font-weight-bold txt-content">
                  Lịch sử khớp lệnh
                </h5>
                <TblTradeHis sym={symbolOrigin} expandSym={symbol} />
              </PerfectScrollBar>
            </Col>
          </Row>
        </Col>
      </div> */}
    </Fragment>
  );
}

export default translate('translations')(memo(TblPhaiSinh));
